import { render, staticRenderFns } from "./EditInventory.vue?vue&type=template&id=504822c4&"
import script from "./EditInventory.vue?vue&type=script&lang=js&"
export * from "./EditInventory.vue?vue&type=script&lang=js&"
import style0 from "./EditInventory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/EditInventory.vue
// module id = null
// module chunks = 